import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

export default class JsPdfWrapper {
  constructor(options = null) {
    this.OPTIONS = {
      jsPDF: {
        orientation: 'l',
        unit: 'px',
        format: 'a4',
        putOnlyUsedFonts: false,
        compress: false,
        precision: 2,
        userUnit: 1.0,
      },
      html2canvas: {
        allowTaint: false,
        backgroundColor: '#ffffff',
        canvas: null,
        foreignObjectRendering: false,
        imageTimeout: 15000,
        logging: false,
        onclone: null,
        proxy: null,
        removeContainer: true,
        scale: window.devicePixelRatio,
        useCORS: false,
      },
    };
    if (options != null) {
      if (options.jsPDF != null) {
        this.OPTIONS.jsPDF = options.jsPDF;
      }
      if (options.html2canvas != null) {
        this.OPTIONS.html2canvas = options.html2canvas;
      }
    }
  }

  async downloadFromHTML(targetElm, fileName, onClone = null) {
    let totalHeight = targetElm.offsetHeight;
    const pdf = new jsPDF(this.OPTIONS.jsPDF.orientation, this.OPTIONS.jsPDF.unit, this.OPTIONS.jsPDF.format);
    const pdfWidth = pdf.internal.pageSize.width;
    const pdfHeight = pdf.internal.pageSize.height;
    window.scrollTo(0, 0);
    this.OPTIONS.html2canvas.onclone = onClone;
    const canvas = await html2canvas(targetElm, this.OPTIONS.html2canvas);

    const widthRatio = pdfWidth / canvas.width;
    const sX = 0;
    const sWidth = canvas.width;
    const sHeight = pdfHeight + (pdfHeight - pdfHeight * widthRatio) / widthRatio;
    const dX = 0;
    const dY = 0;
    const dWidth = sWidth;
    const dHeight = sHeight;
    let pageCnt = 1;
    while (totalHeight > 0) {
      totalHeight -= sHeight;
      let sY = sHeight * (pageCnt - 1);
      const childCanvas = document.createElement('CANVAS');
      childCanvas.setAttribute('width', sWidth);
      childCanvas.setAttribute('height', sHeight);
      const childCanvasCtx = childCanvas.getContext('2d');
      if (totalHeight - sHeight <= 0) {
        childCanvasCtx.fillStyle = '#FFFFFF';
        childCanvasCtx.fillRect(0, 0, dWidth, dHeight);
      }
      childCanvasCtx.drawImage(canvas, sX, sY, sWidth, sHeight, dX, dY, dWidth, dHeight);
      if (pageCnt > 1) {
        pdf.addPage();
      }
      pdf.setPage(pageCnt);
      pdf.addImage(childCanvas, 'PNG', 0, 0, canvas.width * widthRatio, 0);
      pageCnt++;
    }
    pdf.save(fileName);
    window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
  }
}
